import React, { useEffect, useRef, useState } from "react";
import clock from '../assets/images/clock.svg'
import useAxios from "../utils/useAxios";
import { useQuery, useMutation } from "react-query";
import IP from "../variable";

import { formatTime } from "../utils/formatTime";
import toast from "react-hot-toast";

import { Modal, Input, Button, Label, Spinner, ModalHeader, ModalBody, ModalFooter } from "reactstrap";


const MyMeetings = () => {


    let api = useAxios()

    const [modalActive, setModalActive] = useState(false)
    const [meetingSlot, setMeetingSlot] = useState(null)



    const { isLoading, isError, error, data, isSuccess, refetch } = useQuery(
        "my-meetings",
        async () => api.get(`${IP}/company/investor-meetings`),
        { cacheTime: 0 }
    );

    const myMeetings = data?.data?.meetings ?? []


    const sendCancel = () => {
        return api.delete(`/company/cancel-registration/${meetingSlot?.id}`);
    };

    const cancelMutation = useMutation(sendCancel, {
        onSuccess: (res) => {
            toast.success('Meeting Canceled');
            setMeetingSlot(null)
            refetch()
            setModalActive(false)
        },
        onError: (res) => {
            console.log(res)
            setMeetingSlot(null)
            //   toast.error(res?.response?.data?.message); // onResponse("Something went wrong", "error");
        },
    });

    useEffect(() => {
        if (meetingSlot) {
            setModalActive(true)
        }
    }, [meetingSlot])

    return (
        <>
            <div className="table-header">
                You Are Booked For
            </div>

            {
                isLoading ?

                    <div className="placeholder-wave">
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>

                    </div>
                    :

                    myMeetings.length > 0 ?
                    myMeetings.map((meeting) => (

                        <div className="custom-card">

                            <div className="col-6">
                              <span className="main-text" 
                              style={{ 
                                display: 'block',
                                whiteSpace: 'nowrap', 
                                overflow: 'hidden', 
                                textOverflow: 'ellipsis',
                                width: '100%'
                                }}>
                                
                                {meeting.company}
                                
                                </span>


                                <div style={{ fontSize: '0.5rem' }}>{formatTime(meeting?.start_time)} - {formatTime(meeting?.end_time)}</div>
                            </div>
                          
                          
                            <div className="col-6 d-flex justify-content-end">
                                <span className="highlight">
                                    {meeting.location}
                                </span>
                            </div>


                            {/* <div className="col-4 text-end">

                                <button onClick={() => setMeetingSlot(meeting)} className="cancel-btn">
                                    Cancel
                                </button>
                                <br />
                                <div className="before-text">Before 16<sup>th</sup> Sep @ 23:59</div>
                                <div class="modal" tabindex="-1">


                            </div>
                            </div> */}
                        </div>
                    ))    
                    :
                     <div className="text-center">
                        <p>No Records Found</p>
                    </div> 
            }


          <Modal isOpen={modalActive} centered>
    <ModalBody className="text-center py-4">
        <p className="mb-4">
            Are you sure you want to cancel registration with <br />{meetingSlot?.company}?
            <br />
            <span style={{fontSize: '0.8rem'}}>({formatTime(meetingSlot?.start_time)} - {formatTime(meetingSlot?.end_time)})</span>
        </p>
        
        <div className="d-flex justify-content-center gap-2">
           {
                !cancelMutation.isLoading &&
            <button 
            type="button" 
            className="btn-no me-2"
            onClick={() => setModalActive(false)}>
                No
            </button>
                }

            <button 
                type="button" 
                className="btn-yes"
                onClick={() => {
                    cancelMutation.mutate();
                }}
                disabled={cancelMutation.isLoading}>
                {cancelMutation.isLoading ? 'Canceling...' : 'Yes'}
            </button>
        </div>
    </ModalBody>
</Modal>

        </>
    )
}


export default MyMeetings;